import { arrayOf, bool, func, number, shape, string } from "prop-types";
import { useTranslation } from "react-i18next";
import {
  createLabelQuery,
  removeLabelQuery,
  updateLabelQuery
} from "@query";
import { LabelGroups } from "@utils";
import { LabelEditor, Dialog, Button } from "@components";

export const ProjectTypesDialog = ({
  open,
  projectTypes,
  onChange,
  onClose,
}) => {
  const {t} = useTranslation();
  
  const handleCreate = async (name, backgroundColor, fontColor) => {
    const id = await createLabelQuery(name, backgroundColor, fontColor, LabelGroups.PROJECT_TYPES);
    onChange([...projectTypes, { id, name, backgroundColor, fontColor }]);
    return id;
  }
  
  const handleRemove = async (id, updatedList) => {
    await removeLabelQuery(id);
    onChange(updatedList);
  }
  
  const handleUpdate = async (id, name, backgroundColor, fontColor, updatedList) => {
    await updateLabelQuery(id, name, backgroundColor, fontColor);
    onChange(updatedList);
  }
  
  return <Dialog
    disableEnforceFocus
    open={open}
    width={520}
    title={t("views.settings.menu_full.project_types")}
    onClose={onClose}
    actions={
      <Button
        variant="contained"
        onClick={onClose}
      >
        {t("common.close")}
      </Button>
    }
  >
    <LabelEditor
      labelList={projectTypes}
      onCreate={handleCreate}
      onRemove={handleRemove}
      onUpdate={handleUpdate}
      stickyNewLabelRow
    />
  </Dialog>;
}

ProjectTypesDialog.propTypes = {
  open: bool.isRequired,
  projectTypes: arrayOf(shape({
    id: number.isRequired,
    name: string.isRequired,
    backgroundColor: string.isRequired,
    fontColor: string.isRequired,
  })),
  onChange: func.isRequired,
  onClose: func.isRequired,
}